module.exports = __webpack_public_path__ + "static/media/filled.75b715ab.png";